import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  settingsCard: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
  },
  settingLabel: {
    fontWeight: 600,
  },
  linkBox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 1.5),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    marginTop: theme.spacing(1),
  },
  linkText: {
    flex: 1,
    fontFamily: 'monospace',
    fontSize: 13,
    color: theme.palette.text.secondary,
    wordBreak: 'break-all',
    whiteSpace: 'normal',
  },
  warningText: {
    color: theme.palette.warning.main,
    fontSize: 12,
    marginTop: theme.spacing(0.5),
  },
}))

export default useStyles
